import { initTimezone } from '../../utils/cookie';
import { initRequestVerificationToken, initSessionGUID } from '../../utils/sessionStorageInitialization';
import { storageManager } from '../../utils/storageManager';
import { GLOBAL_WINDOW_STORE_KEY } from './const';
import { initNetworkInterceptor } from './interceptor/network';
import { initOldPopupAPI } from './interceptor/oldPlatform';
import { initIndexedDB } from './interceptor/storage';
import { initNetworkGlobals, initUnhandledRejectionHandler } from './network/utils';
import { User } from '../user';
import { AppDataSetProps } from './types';
import { isUndefined } from '../../predicates/type';
import { StyleContextProps } from '../styleContext/types';
import { ToolNavigationData } from '../toolNavigation_old/types';
import {
	pageMainClass,
	pageMainSidebarTransitionedClass,
	pageMainToolNavigationTransitionedClass,
} from '../../utils/const';

function shouldReduceCacheTimeForDevEnv() {
	const value = window.localStorage.getItem('REDUCE_CACHE_TIME');

	return value !== null;
}

function getAppElement() {
	return document.getElementById('root');
}

function getAppDataSet(): {
	activePageId: string;
	customerColor: string;
	isCustomPage: string;
	isIframeMode: string;
	pageTypeId: string;
	styleContext: string;
	toolNavJson: string;
	userContext: string;
	userIsAuthenticated: string;
	userTypeId: string;
} {
	const {
		activePageId,
		customerColor,
		isCustomPage,
		isIframeMode,
		pageTypeId,
		styleContext,
		toolNavJson,
		userContext,
		userIsAuthenticated,
		userTypeId,
	} = getAppElement().dataset;

	return {
		activePageId,
		customerColor,
		isCustomPage,
		isIframeMode,
		pageTypeId,
		styleContext,
		toolNavJson,
		userContext,
		userIsAuthenticated,
		userTypeId,
	};
}

let _AppData: AppDataSetProps;

function getAppData() {
	if (!isUndefined(_AppData)) {
		return _AppData;
	}

	const appDataSet = getAppDataSet();
	let userContext: User;
	let styleContext: StyleContextProps;
	let toolNav: ToolNavigationData;

	try {
		styleContext = JSON.parse(appDataSet.styleContext) as StyleContextProps;
	} catch (e) {}

	try {
		userContext = JSON.parse(appDataSet.userContext) as User;
	} catch (e) {}

	try {
		toolNav = JSON.parse(appDataSet.toolNavJson) as ToolNavigationData;
	} catch (e) {}

	function isTrueFromString(prop) {
		return String(prop).toLowerCase() === 'true';
	}

	_AppData = {
		isCustomPage: isTrueFromString(appDataSet.isCustomPage),
		isIframeMode: isTrueFromString(appDataSet.isIframeMode),
		userIsAuthenticated: isTrueFromString(appDataSet.userIsAuthenticated),
		userContext,
		styleContext,
		toolNav,
		activePageId: appDataSet.activePageId,
		customerColor: appDataSet.customerColor,
		pageTypeId: appDataSet.pageTypeId,
		userTypeId: appDataSet.userTypeId,
	};

	return _AppData;
}

function switchFuckCursorProperty(on: boolean) {
	if (on) {
		document.documentElement.style.setProperty(
			'--custom-cursor',
			"url('https://fav.farm/%F0%9F%96%95?svg') 15 0, auto",
		);
	} else {
		document.documentElement.style.removeProperty('--custom-cursor');
	}
}

function toggleFuckCursor() {
	const hasCursorSettings = localStorage.getItem('hasCustomCursor');
	const on = hasCursorSettings === null || hasCursorSettings === 'false';

	localStorage.setItem('hasCustomCursor', String(on));

	switchFuckCursorProperty(on);
}

function initFuckCursor() {
	const hasCustomCursor = localStorage.getItem('hasCustomCursor');

	if (hasCustomCursor === 'true') {
		switchFuckCursorProperty(true);
	}
}

function appGlobalInit() {
	window[GLOBAL_WINDOW_STORE_KEY] = {};
	window['fuckIt'] = toggleFuckCursor;
	initFuckCursor();

	initUnhandledRejectionHandler();

	storageManager.cleanUpToVersion();
	initNetworkGlobals();
	initTimezone();
	initIndexedDB();
	initSessionGUID();
	initRequestVerificationToken();
	initNetworkInterceptor();
	initOldPopupAPI();
}

const getPageElement = () => document.querySelector<HTMLDivElement>(`.${pageMainClass}`);

function togglePageMainSidebarTransitionedClass(add) {
	const pageElement = getPageElement();

	if (!pageElement) return;

	if (add) {
		pageElement.classList.add(pageMainSidebarTransitionedClass);
	} else {
		pageElement.classList.remove(pageMainSidebarTransitionedClass);
	}
}

function togglePageMainToolNavigationTransitionedClass(add) {
	const pageElement = getPageElement();

	if (!pageElement) return;

	if (add) {
		pageElement.classList.add(pageMainToolNavigationTransitionedClass);
	} else {
		pageElement.classList.remove(pageMainToolNavigationTransitionedClass);
	}
}

export {
	appGlobalInit,
	shouldReduceCacheTimeForDevEnv,
	getAppElement,
	getAppData,
	togglePageMainSidebarTransitionedClass,
	togglePageMainToolNavigationTransitionedClass,
};
